import React from 'react';
import { Icon, Tooltip, TooltipManager } from '@ao-internal/components-react';
import { sendBeacon } from '@ao-internal/digital-data';

export const DeliveryTooltip = ({}) => {
	return (
		<>
			<TooltipManager id="canvas-example" closeDelay={1} className="z-10">
				{({ referenceProps, tooltipProps }) => (
					<>
						{tooltipProps.isOpen
							? sendBeacon('TrackClick', {
									type: 'tooltip',
									name: 'Delivery Price Tooltip Hover/Click',
									section: 'price-pod',
							  })
							: null}
						<div className="text-cta-action ml-1">
							<Icon {...referenceProps} icon="info" size="sm" />
						</div>

						<Tooltip
							{...tooltipProps}
							hideCloseButton={true}
							placement="top-start"
							maxWidth="xs"
							className="z-10">
							<p className="text-xs m-0 w-48">
								Estimated charge. Actual delivery costs may vary by date, time
								slot selection, geographical location, or if arriving in two
								deliveries when ordering more than one product.
							</p>
						</Tooltip>
					</>
				)}
			</TooltipManager>
		</>
	);
};
